/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TreePlotter v3 API
 * TreePlotter v3 API
 * OpenAPI spec version: 4.51.0
 */
import { useMutation } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from "@tanstack/react-query";

import type {
  BadRequestResponse,
  ForbiddenErrorResponse,
  Id,
  SubmitInspection,
  SubmitInspection202,
  UnauthorizedErrorResponse,
} from ".././model";

import { httpClient } from "../../../src/common/infrastructure/api/http-client";

/**
 * Submit a new inspection for an asset. An inspection can only be submitted once. Photos may optionally be
linked at submission time.

For a `TreeD` inspection the submitted field ids are checked against the tenant's field configuration
before the request is accepted: a field that is unknown, has no tag, or is tagged outside the TreeD
schema is answered `400` (`ERR_VALIDATION`, with `details.violations` and `details.offSchemaTags`) and
nothing is queued. A `TreeD` body whose `assetAttributes` is missing, `null`, a scalar or an array is
answered the same `400`, without `details`, before the field configuration is read. Other inspection
types are validated after the `202`, in the queued handler.

 * @summary Submit inspection
 */
export const submitInspection = (
  tenantId: Id,
  inspectionId: Id,
  submitInspection: SubmitInspection,
  signal?: AbortSignal
) => {
  return httpClient<SubmitInspection202>({
    url: `/command-service/tenant/${tenantId}/inspection/aggregate/inspection/${inspectionId}/submit-inspection`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: submitInspection,
    signal,
  });
};

export const getSubmitInspectionMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedErrorResponse
    | ForbiddenErrorResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitInspection>>,
    TError,
    { tenantId: Id; inspectionId: Id; data: SubmitInspection },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitInspection>>,
  TError,
  { tenantId: Id; inspectionId: Id; data: SubmitInspection },
  TContext
> => {
  const mutationKey = ["submitInspection"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitInspection>>,
    { tenantId: Id; inspectionId: Id; data: SubmitInspection }
  > = (props) => {
    const { tenantId, inspectionId, data } = props ?? {};

    return submitInspection(tenantId, inspectionId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitInspectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitInspection>>
>;
export type SubmitInspectionMutationBody = SubmitInspection;
export type SubmitInspectionMutationError =
  | BadRequestResponse
  | UnauthorizedErrorResponse
  | ForbiddenErrorResponse;

/**
 * @summary Submit inspection
 */
export const useSubmitInspection = <
  TError =
    | BadRequestResponse
    | UnauthorizedErrorResponse
    | ForbiddenErrorResponse,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof submitInspection>>,
      TError,
      { tenantId: Id; inspectionId: Id; data: SubmitInspection },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof submitInspection>>,
  TError,
  { tenantId: Id; inspectionId: Id; data: SubmitInspection },
  TContext
> => {
  const mutationOptions = getSubmitInspectionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
